export var navHeight = {
    num: 71,
    px: '71px',
};
export var applicationMaxWidth = {
    num: 1176,
    px: '1176px',
};
//# sourceMappingURL=constants.js.map